import { memo } from 'react'
import { HashLink } from 'react-router-hash-link'

import { cx } from '@/lib/styles'

import { ButtonProps } from './types'

import styles from './Button.module.scss'

const Button = ({
  type = 'primary',
  size = 'medium',
  className,
  disabled = false,
  onClick,
  withBorder = false,
  loading,
  linkTo,
  children,
  ...restProps
}: ButtonProps) => {
  const isDisabled = disabled || loading

  const buttonClassNames = cx(
    {
      [styles.withBorder]: withBorder,
    },
    [styles.button],
    [styles[type]],
    [styles[size]],
    size === 'large' ? 't-button-big' : 't-button',
    className,
  )

  const handleClick = () => {
    onClick?.()
  }

  if (linkTo !== undefined) {
    return (
      <HashLink
        className={buttonClassNames}
        smooth
        to={linkTo}
        {...(handleClick && { onClick: handleClick })}
      >
        {children}
      </HashLink>
    )
  }

  return (
    <button
      className={buttonClassNames}
      onClick={handleClick}
      disabled={isDisabled}
      {...restProps}
    >
      {children}
    </button>
  )
}

export default memo(Button)
